import styled from 'styled-components';
import { mediaQuery } from '../../../styles/utils';

export default styled.div`
    &.account-menu-container {
        background-color: var(--surface-level-1-bg);
        border: var(--surface-level-1-border);
        border-radius: var(--ui-radius);
        padding: var(--spacing-24);
        max-width: 450px;
        margin: 0 auto;
        @media ${mediaQuery.isPhone} {
            border: none;
            overflow: auto;
        }

        .brand-logo {
            display: flex;
            justify-content: space-between;
            width: 100%;
            align-items: center;

            text-transform: uppercase;
            font-size: var(--font-10);
        }

        .account-menu-branding {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: var(--spacing-16);
            margin-bottom: var(--spacing-16);
            display: none;
            @media ${mediaQuery.isPhone} {
                display: flex;
            }
        }

        .account-info {
            display: flex;
            justify-content: center;
            gap: var(--spacing-4);
            width: 100%;
            padding: var(--spacing-12) 0;

            & + button {
                width: calc(100% - (var(--spacing-12) * 2));
                margin: 0 auto;
            }
        }

        .info-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: var(--spacing-4);

            color: var(--font-color-primary);
            text-align: center;
            cursor: pointer;

            .info-box-content {
                font-size: 1.5rem;
                font-weight: var(--font-weight-bold);
                ${({ theme }) => theme.optimizeFontRendering};
                text-transform: uppercase;

                &.balance {
                    color: var(--color-highlight);
                }
            }

            .info-box-label {
                text-transform: uppercase;
                font-size: var(--font-10);
            }
        }

        .account-links-primary {
            display: flex;
            justify-content: center;
            gap: var(--spacing-8);
            padding: var(--spacing-16) var(--spacing-12);
            margin-top: var(--spacing-8);
        }

        .account-links {
            display: flex;
            flex-direction: column;
            padding: var(--spacing-24) var(--spacing-12);
            border-top: 1px dashed var(--surface-level-2-line-color);
            border-bottom: 1px dashed var(--surface-level-2-line-color);
            gap: 20px;
        }

        .auth-buttons {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: var(--spacing-8);
        }

        .bonus-code-entry {
            width: 100%;
        }

        button:last-of-type {
            margin-top: var(--spacing-12);
        }

        .bonus-code-entry button {
            margin-top: 0;
        }
    }
`;
